export default (val => {
  const trimmed = typeof val === 'string' ? val.trim() : val;
  return trimmed === null || trimmed === undefined || trimmed === '';
});